import { render, staticRenderFns } from "./identityAuthentication.vue?vue&type=template&id=5cffa0ac&scoped=true&"
import script from "./identityAuthentication.vue?vue&type=script&lang=js&"
export * from "./identityAuthentication.vue?vue&type=script&lang=js&"
import style0 from "./identityAuthentication.vue?vue&type=style&index=0&id=5cffa0ac&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cffa0ac",
  null
  
)

export default component.exports